





















import { computed, defineComponent,nextTick, inject, onMounted, onUnmounted, reactive, ref, watch } from '@vue/composition-api'
import ChatHeader from "./components/ChatHeader.vue";
import HeaderMessage from "./components/HeaderMessage.vue";
import ChatFooter from "./components/ChatFooter.vue";
import ChatMessage from "./components/ChatMessage.vue";
export default defineComponent({
    components:{
        ChatHeader,
        ChatFooter,
        ChatMessage,
        HeaderMessage
    },
    setup(props, { root, refs,emit  }) {
      const closeChataiDrawer=()=>{
          emit('close-drawer');
      }

        return {
          closeChataiDrawer
        }
    }
})
